import { Build, forceUpdate, h, Host, readTask } from "@stencil/core";
export class CookieBanner {
    visibleWatcher() {
        if (this.visible) {
            this.el.removeAttribute('hidden');
            const modal = this.el.querySelector('.modal');
            const backdrop = this.el.querySelector('.modal-backdrop');
            if (modal === null) {
                return;
            }
            document.body.classList.add('modal-open');
            modal.style.display = 'flex';
            setTimeout(() => {
                modal.classList.add('in');
                backdrop.classList.add('in');
            });
        }
        else {
            document.body.classList.remove('modal-open');
            this.el.remove();
        }
    }
    async open() {
        this.visible = true;
    }
    async close() {
        this.visible = false;
    }
    constructor() {
        this.forceClosed = false;
        this.visible = false;
        this.consentSettings = {
            essential: true,
            statistic: false
        };
        this.settingsChangedListener = (consentSettings) => {
            this.consentSettings = Object.assign(this.consentSettings, consentSettings);
            forceUpdate(this.el);
        };
        this.consentManager = window['uvexConsentManager'];
    }
    componentWillLoad() {
        if (navigator.userAgent.match(/Chrome-Lighthouse/i) || !Build.isBrowser) {
            return;
        }
        this.consentManager.addListener(this.settingsChangedListener);
        this.consentSettings = Object.assign(this.consentSettings, this.consentManager.consentSettings);
        this.visible = !this.consentManager.hasCookie;
        if (this.forceClosed) {
            this.visible = false;
        }
        if (this.visible) {
            this.trackEvent('view');
        }
    }
    componentDidLoad() {
        readTask(() => this.visibleWatcher());
    }
    disconnectedCallback() {
        this.consentManager.removeListener(this.settingsChangedListener);
    }
    save(event) {
        event.preventDefault();
        this.consentManager.updateConsentSettings(this.consentSettings);
        this.trackEvent('accept', this.consentManager.consentSettings);
        this.close();
    }
    saveAll(event) {
        event.preventDefault();
        this.consentManager.updateConsentSettings({
            essential: true,
            statistic: true
        });
        if ('ga' in window) {
            ga('send', {
                'hitType': 'event',
                'eventCategory': 'cookie-banner',
                'eventAction': 'accepted',
                'nonInteraction': true
            });
        }
        this.trackEvent('accept_all', this.consentManager.consentSettings);
        this.close();
    }
    render() {
        return h(Host, { key: '6ecd93255707101e4347a1b869acf68ec4f6b560' }, h("div", { key: '95629a844772745790e7a0f3ea638d56768554f1', class: "modal modal-cookie fade", role: "dialog" }, h("div", { key: 'f83ad11301dc7f5f4694f0728660ede163ca6f7b', class: "modal-dialog modal-video" }, h("div", { key: 'b2931e60406761d581418af3cb38192afa87ac8f', class: "modal-content" }, h("h3", { key: '8940948e96c7aba32db14e09b12008d165dcb200' }, h("slot", { key: '4fcdd228e3ea3cf8b873608421e0274d812384e0', name: "headline" })), h("p", { key: 'd34831d28aa4090ca39d6fd45f06c93e369ec948' }, h("slot", { key: '35a5963efb30e6a5cdaa9ee827a708e7c41b246b', name: "text" })), h("div", { key: '2c9c5f8bb804d3cd050d59e626ead7b21f506a53', class: "actions" }, h("a", { key: 'bfec06791fc436ed91daadf690a02b11d4212560', class: "btn btn-dark", onClick: (event) => this.save(event) }, h("slot", { key: '2d64be8d95011cc28861b1b68bb74216ba7330c5', name: "button-reject" })), h("a", { key: '581dd313e1cc89a95dd6c89086c635974535f6c6', class: "btn btn-dark", onClick: (event) => this.saveAll(event) }, h("slot", { key: '5d9f1ad608ee6d362a7cffd7ea3ef2bc1cc84e5d', name: "button-accept" })))))), h("div", { key: 'd8e8d6465a44ba0ef4225267de1f24e228f5c96c', class: "modal-backdrop fade" }));
    }
    trackEvent(action, eventParams = {}) {
        var _a, _b;
        if ('gtag' in window) {
            gtag('event', `cookiebanner_${action}`, eventParams);
        }
        const trackingHost = ((_b = (_a = window['uvexStyleGuide']) === null || _a === void 0 ? void 0 : _a.proxy) === null || _b === void 0 ? void 0 : _b.tracking) || '';
        if (trackingHost !== '') {
            const url = new URL(`cb/${action}`, trackingHost);
            const image = document.createElement('img');
            image.src = url.toString();
            image.height = 1;
            image.width = 1;
            image.style.display = 'none';
        }
    }
    static get is() { return "uvex-cookie-banner"; }
    static get properties() {
        return {
            "forceClosed": {
                "type": "boolean",
                "attribute": "force-closed",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "visible": {},
            "consentSettings": {}
        };
    }
    static get methods() {
        return {
            "open": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "close": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "visible",
                "methodName": "visibleWatcher"
            }];
    }
}
//# sourceMappingURL=cookie-banner.js.map
